/**
 * Leasing comparables row
 */
export class LeasingComparablesRow{

  /**
   * The OID
   */
  oid: number;

  /**
   * The comparable number
   */
  comparableNumber: number;

  /**
   * The quarter
   */
  quarter: string;

  /**
   * The size
   */
  size: number;

  /**
   * The address
   */
  address: string;

  /**
   * The rent
   */
  rent: number;

  /**
   * The condition
   */
  condition: string;

  /**
   * The term
   */
  term: number;

  /**
   * The comments
   */
  comments: string;
}
